import { gql, useMutation } from '@apollo/client';

const SEND_TRAINING_EMAIL_RESULT_FIELDS = gql`
  fragment SendTrainingEmailResultFields on SendTrainingEmailResult {
    sent
    skipped
    errors
  }
`;

const SEND_TRAINING_EMAIL = gql`
  ${SEND_TRAINING_EMAIL_RESULT_FIELDS}
  mutation sendTrainingEmail($employeeId: String!, $trainingUrl: String!, $trainingTitle: String!) {
    sendTrainingEmail(employeeId: $employeeId, trainingUrl: $trainingUrl, trainingTitle: $trainingTitle) {
      ...SendTrainingEmailResultFields
    }
  }
`;

const SEND_ALL_TRAINING_EMAILS = gql`
  ${SEND_TRAINING_EMAIL_RESULT_FIELDS}
  mutation sendAllTrainingEmails(
    $applicationId: String
    $localQuestionnaireId: String
    $documentNumber: Int
    $trainingTitle: String!
    $type: String!
    $baseUrl: String!
    $withConfirmation: Boolean
  ) {
    sendAllTrainingEmails(
      applicationId: $applicationId
      localQuestionnaireId: $localQuestionnaireId
      documentNumber: $documentNumber
      trainingTitle: $trainingTitle
      type: $type
      baseUrl: $baseUrl
      withConfirmation: $withConfirmation
    ) {
      ...SendTrainingEmailResultFields
    }
  }
`;

export interface SendTrainingEmailResult {
  sent: number;
  skipped: number;
  errors: string[];
}

export interface SendTrainingEmailMutationResult {
  sendTrainingEmail: SendTrainingEmailResult;
}

export interface SendTrainingEmailInput {
  employeeId: string;
  trainingUrl: string;
  trainingTitle: string;
}

export interface SendAllTrainingEmailsMutationResult {
  sendAllTrainingEmails: SendTrainingEmailResult;
}

export interface SendAllTrainingEmailsInput {
  applicationId?: string;
  localQuestionnaireId?: string;
  documentNumber?: number;
  trainingTitle: string;
  type: string;
  baseUrl: string;
  withConfirmation?: boolean;
}

export function useSendTrainingEmailMutation() {
  return useMutation<SendTrainingEmailMutationResult, SendTrainingEmailInput>(SEND_TRAINING_EMAIL);
}

export function useSendAllTrainingEmailsMutation() {
  return useMutation<SendAllTrainingEmailsMutationResult, SendAllTrainingEmailsInput>(SEND_ALL_TRAINING_EMAILS);
}
